import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import DefaultImage from '@/components/common/DefaultImage';
import PerformanceLabel from '@/components/common/PerformanceLabel';
import Star from 'comp/star/Star';
import { getStar } from '@/utils/getStar';
import filters from '@/utils/filters';
import { parseDetailUrl } from "@/utils";
export default {
  name: 'recommend-item',
  components: {
    DefaultImage: DefaultImage,
    PerformanceLabel: PerformanceLabel,
    Star: Star
  },
  props: {
    content: {
      type: Object,
      default: null
    },
    defaultColor: {
      type: String,
      value: "#F5F5F5"
    },
    isRecommendABtest: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      isImageLoaded: false,
      isImageLoadedError: false
    };
  },
  created: function created() {
    this.content.posterUrl && this.preLoadImage(this.content.posterUrl);
  },
  watch: {
    "content.posterUrl": function contentPosterUrl(val) {
      this.preLoadImage(val);
    }
  },
  computed: {
    listActivityTagUrlPlus: function listActivityTagUrlPlus() {
      return this.content && this.content.couponActivityTagVO && this.content.couponActivityTagVO.listActivityTagUrlPlus;
    },
    showGeneralAgentIcon: function showGeneralAgentIcon() {
      if (!this.content) return false;
      var _this$content = this.content,
        exclusive = _this$content.exclusive,
        generalAgent = _this$content.generalAgent;
      if (generalAgent && !exclusive) {
        return true;
      }
      return false;
    },
    showExclusiveAgentIcon: function showExclusiveAgentIcon() {
      return this.content && !!this.content.exclusive;
    },
    labelList: function labelList() {
      var content = this.content;
      if (!content) return null;
      var seatType = content.seatType,
        discountTag = content.discountTag,
        hasPromotion = content.hasPromotion;
      var leftIconNum = 2;
      if (this.showExclusiveAgentIcon) {
        leftIconNum--;
      }
      if (this.showGeneralAgentIcon) {
        leftIconNum--;
      }
      var list = [];
      var needDiscountTag = hasPromotion || discountTag ? '有优惠' : null;
      if (needDiscountTag) {
        list.push({
          icon: null,
          label: needDiscountTag
        });
      }
      if (seatType === 1) {
        list.push({
          icon: 'https://obj.pipi.cn/festatic/common/image/4cf16c52f80dc40f4b2485fa95f42b76.png',
          label: '选座购票'
        });
      }
      return list.slice(0, leftIconNum);
    },
    priceLabel: function priceLabel() {
      var content = this.content;
      if (!content) return '';
      var priceRange = content.priceRange,
        lowestPrice = content.lowestPrice,
        minSellPrice = content.minSellPrice;
      if (minSellPrice != null) {
        return "".concat(minSellPrice);
      }
      if (priceRange === '价格待定') {
        return '价格待定';
      }
      if (lowestPrice === undefined || lowestPrice === null) return '';
      return "".concat(lowestPrice);
    },
    // 是否是游戏剧场项目
    isGameProject: function isGameProject() {
      return this.content.categoryId === 14;
    },
    // 是否是拼场售卖
    isShowPoolSale: function isShowPoolSale() {
      //  1-拼场，2-单独售卖
      return this.content.saleType === 1;
    }
  },
  methods: {
    getStarNum: getStar,
    handleJump: function handleJump() {
      var _ref = this.content || {},
        performanceId = _ref.performanceId,
        jumpUrl = _ref.jumpUrl,
        dataSeed = _ref.dataSeed,
        jumpDetailUrl = _ref.jumpDetailUrl;
      if (!jumpUrl) {
        jumpUrl = "/detail/".concat(performanceId);
      }
      if (jumpDetailUrl) {
        jumpUrl = parseDetailUrl(jumpDetailUrl);
      }
      if (!jumpUrl) return;
      if (dataSeed) {
        window.seedAction(Object.assign({}, dataSeed, {
          needTag: true
        }));
      }
      this.go(jumpUrl, {
        _blank: true
      });
    },
    preLoadImage: function preLoadImage(src) {
      var _this = this;
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 169 * 2;
      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 225 * 2;
      if (src) {
        // 针对列表预加载统一处理
        src = filters.imgSize(src, width, height);
        var tempIMG = new Image();
        tempIMG.onload = function () {
          _this.isImageLoaded = true;
        };
        tempIMG.onerror = function () {
          _this.isImageLoaded = true;
          _this.isImageLoadedError = true;
        };
        tempIMG.src = src;
      } else {
        this.isImageLoaded = false;
      }
    }
  }
};